import ApiService from "@/utils/request";

export const HomeServe = {
  popular(params) {
    return ApiService.query("/policy/v2/inner/popular/", params);
  },
  subscribe(params = {}) {
    return ApiService.query("/policy/v2/inner/subscribe/", params);
  },
};
